import React, { useState, useEffect } from "react";
import RoleSelector from "../../../components/Akses/RoleSelector";
import AccessTable from "../../../components/Akses/AccessTable";
import { getAllRoles } from "../../../services/roleService";
import {
  getPermissionsByRoleId,
  updatePermissionsByRoleId,
} from "../../../services/permissionService";

const JenisPengguna = () => {
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [tempPermissions, setTempPermissions] = useState({});
  const [roleList, setRoleList] = useState([]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const roles = await getAllRoles();
        const filteredRoles = roles.filter(
          (r) => r.name.toLowerCase() !== "superadmin"
        );
        setRoleList(filteredRoles);
      } catch (error) {
        console.error("Gagal mengambil roles:", error);
      }
    };
    fetchRoles();
  }, []);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!selectedRoleId) return;
      try {
        const perms = await getPermissionsByRoleId(selectedRoleId);
        setTempPermissions(perms);
        console.log("raw perms from API:", perms);
      } catch (err) {
        console.error("Gagal ambil permissions:", err);
        setTempPermissions({});
      }
    };
    fetchPermissions();
  }, [selectedRoleId]);

  const handleUpdateAccess = async () => {
    if (!selectedRoleId) return;

    try {
      console.log("Permissions Object:", tempPermissions);

      await updatePermissionsByRoleId(selectedRoleId, tempPermissions);

      const roleName = roleList.find((r) => r.id === selectedRoleId)?.name;
      alert(`✅ Akses berhasil disimpan untuk role: ${roleName}`);
    } catch (err) {
      console.error("Gagal update permissions:", err);
      alert("❌ Gagal menyimpan akses.");
    }
  };

  const handleRoleChange = (newRoleId) => {
    setSelectedRoleId(newRoleId);
    setTempPermissions({}); // reset sementara
  };

  const handleCheckboxChange = (moduleKey, actionKey, checked) => {
    setTempPermissions((prev) => {
      const currentModule = prev[moduleKey] || {};
      let updatedModule = { ...currentModule };

      const actionKeys = ["view", "add", "edit", "delete", "print", "semua"];

      if (actionKey === "semua") {
        actionKeys.forEach((key) => {
          updatedModule[key] = checked;
        });
      } else {
        updatedModule[actionKey] = checked;

        const allChecked = actionKeys
          .filter((key) => key !== "semua")
          .every((key) => updatedModule[key]);

        updatedModule["semua"] = allChecked;
      }

      return {
        ...prev,
        [moduleKey]: updatedModule,
      };
    });
  };

  return (
    <div className="p-6 pl-64">
      <div className="flex items-center justify-between mb-6">
        <RoleSelector
          roles={roleList}
          selectedRoleId={selectedRoleId}
          onChange={handleRoleChange}
        />
        {selectedRoleId && (
          <button
            onClick={handleUpdateAccess}
            className="px-5 py-2 text-white transition bg-green-600 rounded-lg hover:bg-green-700"
          >
            🔄 Update Akses
          </button>
        )}
      </div>

      {selectedRoleId && (
        <AccessTable
          roleId={selectedRoleId}
          access={tempPermissions}
          onChange={handleCheckboxChange}
        />
      )}
    </div>
  );
};

export default JenisPengguna;
